import { PollQuestionProps } from './types';

export const PollQuestion = ({ children }: PollQuestionProps) => <div className="">{children}</div>;
